import React, { Component } from 'react'
import { connect } from 'react-redux'
import UserActions from '../../actions/user/user-actions'
import UIActions from '../../actions/ui/ui-actions'
import DisplaySchema from '../common/displaySchema/schemas/DisplaySchema'
import DisplayBySchemaCP from '../common/displaySchema/DisplayBySchemaCP'
import DisplayTypes from '../common/displaySchema/displayTypes/DisplayTypes'
import FoldoutCP from '../common/displaySchema/FoldoutCP'
import UFT from '../../common/UserFacingText'
import GameRegister from '../../common/GameRegister'
import Utils from '../../common/Utils'


class NewGameCP extends Component {
  constructor () {
    super()
    // this.state = {}

    // collection test
    /*
    this.newGameMeta = new DisplaySchema({
      displayName: 'New Game',
      displayType: DisplayTypes['COLLECTION'].id,
      properties: {
        textIn: new DisplaySchema({
          displayName: 'Name',
          displayType: DisplayTypes['TEXT'].id,
          displayOrder: 2
        }),
        isDo: new DisplaySchema({
          displayName: 'Do It',
          displayType: DisplayTypes['CHECK_BOX'].id,
          displayOrder: 1
        }),
        gameType: new DisplaySchema({
          displayName: 'Game Type',
          displayType: DisplayTypes['DROPDOWN'].id,
          displayOrder: 3,
          displayTypeProps: {
            enums: [
              { label: 'Shark', value: 'Shark' },
              { label: 'Dolphin', value: 'Dolphin' },
              { label: 'Whale', value: 'Whale' },
              { label: 'Octopus', value: 'Octopus' },
              { label: 'Crab', value: 'Crab' },
              { label: 'Lobster', value: 'Lobster' },
            ]
          }
        }),
        players: new DisplaySchema({
          displayName: 'Players',
          displayType: DisplayTypes['MULTISELECT'].id,
          displayOrder: 4,
          displayTypeProps: {
            enums: [
              { label: 'Shark', value: 'Shark' },
              { label: 'Dolphin', value: 'Dolphin' },
              { label: 'Whale', value: 'Whale' },
              { label: 'Octopus', value: 'Octopus' },
              { label: 'Crab', value: 'Crab' },
              { label: 'Lobster', value: 'Lobster' },
            ]
          }
        }),
      }
    })
    */
    
    this.newGameMeta = new DisplaySchema({
      displayName: 'New Game',
      displayType: DisplayTypes['COLLECTION'].id,
      properties: {
        gameName: new DisplaySchema({
          displayName: 'Name',
          displayType: DisplayTypes['TEXT'].id,
          displayOrder: 2
        }),
        gameType: new DisplaySchema({
          displayName: 'Game Type',
          displayType: DisplayTypes['DROPDOWN'].id,
          displayOrder: 3,
          displayTypeProps: {
            enums: []
          }
        }),
        players: new DisplaySchema({
          displayName: 'Players',
          displayType: DisplayTypes['MULTISELECT'].id,
          displayOrder: 4,
          displayTypeProps: {
            enums: [],
            placeholder: 'and You',
          }
        }),
      }
    })

    this.initFormVals = {
      'gameName': 'New Game',
      'gameType': null,
      'players': [],
      'settings':{}
    }

    this.formVals = Utils.clone(this.initFormVals)

    this.state = {
      'formVals': this.formVals,
      'formMeta': this.newGameMeta,
      'isFormValid': true,
    }
    // */
  }

  resetForm () {
    this.setState({
      'formVals': this.initFormVals,
      'formMeta': this.newGameMeta,
      'isFormValid': true,
    })
  }

  validateForm (formVals = this.state.formVals) {
    let isValid = true

    let formMeta = Utils.clone(this.state.formMeta)
    formMeta.properties.gameName.invalidMessage = ''
    formMeta.properties.gameType.invalidMessage = ''
    formMeta.properties.players.invalidMessage = ''

    if (!formVals.gameName || formVals.gameName === '') {
      isValid = false
      formMeta.properties.gameName.invalidMessage = UFT.NAME_SHOULD_NOT_BE_BLANK
    }

    if (!formVals.gameType 
      || !this.props.gameTypes[formVals.gameType])
    {
      isValid = false
      formMeta.properties.gameType.invalidMessage = UFT.CHOOSE_A_GAME
    } else if (!this.props.gameTypes[formVals.gameType].player_counts.includes(formVals.players.length+1)) { 
      isValid = false
      formMeta.properties.players.invalidMessage = UFT.INVALID_PLAYER_COUNT
    }

    this.setState({
      'formMeta': formMeta,
      'isFormValid': isValid,
    })

    return isValid
  }

  render () {

    let pLabel = 'Players'
    if (this.state.formVals.gameType 
      && this.props.gameTypes[this.state.formVals.gameType].player_counts)
    {
      pLabel += ` (${this.props.gameTypes[this.state.formVals.gameType].player_counts})`
    }

    let formMeta = Utils.clone(this.state.formMeta)
    formMeta.properties.gameType.displayTypeProps.enums = this.props.gameTypeEnums
    formMeta.properties.players.displayTypeProps.enums = this.props.friendEnums
    formMeta.properties.players.displayName = pLabel

    // switch by gameType here
    let settingsContain = <></>
    if (this.state.formVals.gameType) {
      let SettingsEle = GameRegister.getGameElements(this.state.formVals.gameType).newForm
      if (SettingsEle) {
        settingsContain = <SettingsEle objPath='newGame.settings' value={this.state.formVals.settings} onChange={(event, val, path) => this.onFormChange(event, val, path)} />
      }
    }

    return (
      <FoldoutCP displayName={this.newGameMeta.displayName} isOpen={this.props.isNewGameTabOpen} onClick={(event, isOpen) => this.onToggleFoldout(event, isOpen)}>
        <DisplayBySchemaCP objPath='newGame' 
          isEditable={true} 
          value={this.state.formVals} 
          meta={formMeta} 
          onChange={(event, val, path) => this.onFormChange(event, val, path)} 
          omitRootContain={true} />
        <div className='spacerEle'></div>
        {settingsContain}
        <div className='spacerEle'></div>
        <div className='spacerEle'>
          <button className='bcioButton' role='' disabled={!this.state.isFormValid} onClick={event => this.onSendInvite(event)} >send invite</button>
        </div>
      </FoldoutCP>
    )
  }

  onToggleFoldout (event, isOpen) {
    this.props.setNewGameTab(isOpen)
  }

  onSendInvite (event) {
    let isValid = this.validateForm()
    if (isValid) {
      let invite = {
        'gameName': this.state.formVals.gameName,
        'gameType': this.state.formVals.gameType,
        'players': this.state.formVals.players.map(player => player.value),
        'settings': this.state.formVals.settings,
      }
      
      this.props.sendGameInvite(invite)
      this.onToggleFoldout(null, false)
      //this.props.setInviteTab(true)
      this.resetForm()
    }
  }

  onFormChange (event, val, path) {
    var pathAr = Utils.pathTextToPathArray(path)
    pathAr.shift() // why this?
    let formVals = Utils.clone(this.state.formVals)
    Utils.setByPathArray(formVals, pathAr, val)
    if (!this.state.isFormValid) this.validateForm(formVals)
    this.setState({
      'formVals': formVals,
    })
  }

}

const deriveGameTypeEnum = (gameTypes) => {
  let enums = []
  Object.values(gameTypes).forEach(gameType => {
    enums.push({
      'label': gameType.display_name, 
      'value': gameType.name,
    })
  })
  return enums
}

const deriveFriendsEnum = (userId, friends) => {
  let enums = []
  Object.values(friends).forEach(friend => {
    if (friend.id !== userId) {
      enums.push({
        'label': friend.name, 
        'value': friend.id,
      })
    }
  })
  return enums
}

const mapStateToProps = (state) => {
  return {
    isNewGameTabOpen: state.ui.isNewGameTabOpen,
    gameTypes: state.system.gameTypes,
    gameTypeEnums: deriveGameTypeEnum(state.system.gameTypes),
    friendEnums: deriveFriendsEnum(state.user.user.id, state.user.friends),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    sendGameInvite: invite => dispatch(UserActions.sendGameInvite(invite)),
    setNewGameTab: isNewGameTabOpen => dispatch(UIActions.setNewGameTab(isNewGameTabOpen)),
    //setInviteTab: isTabOpen => dispatch(UIActions.setInviteTab(isTabOpen)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(NewGameCP)
